import { DateObject } from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persianLocale from 'react-date-object/locales/persian_fa';

export const formatChatTimestamp = (timestamp: string) => {
  const utcDate = new Date(timestamp);

  return (
    utcDate.toLocaleTimeString('fa-IR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Asia/Tehran'
    }) +
    ' ' +
    new DateObject({
      date: utcDate,
      calendar: persian,
      locale: persianLocale
    }).format('YYYY/MM/DD')
  );
};
